import { supabase } from '../lib/supabase';

// Netopia LIVE API endpoint
//const NETOPIA_API_URL = 'https://secure.mobilpay.ro/payment/card/start';
const NETOPIA_API_URL = 'https://secure.mobilpay.ro/pay/payment/card/start';

// Netopia sandbox API endpoint
//const NETOPIA_API_URL = 'https://secure.sandbox.netopia-payments.com/payment/card/start';

// POS signature provided by Netopia
const POS_SIGNATURE = '2UB2-DJQT-OANZ-ZD8B-YR5Q';

// Authorization key live environment
const AUTH_KEY = 'QWOZuKNRrYiaAmNN1l4vywgnXOo0L7tpqU87M8mI7hWt-PA5GvJ0cWn_Tdot';

// Authorization key sandbox environment
//const AUTH_KEY = 'VqI2kbMV2SOlbPKOOLFN7yGGpA5iiL3MTGOFeIUyF4tNeerV-Uag5_9Dtow=';

// Netopia payment processing service
export const netopiaService = {
  // Create a new payment request
  createPayment: async (patientId: string, patientEmail: string, patientName: string, discountCode: string = 'none') => {
    try {
      // Generate a unique order ID using timestamp + patient ID
      const orderId = `DO-${Date.now()}-${patientId.substring(0, 8)}`;
      
      // Store payment attempt in Supabase
      await supabase.from('payment_attempts').insert({
        patient_id: patientId,
        order_id: orderId,
        amount: 900,
        status: 'initiated',
        payment_method: 'card',
        discount_code: discountCode,
      });

      // Split patient name into first and last name
      const [firstName, ...lastNameParts] = patientName.split(' ');
      const lastName = lastNameParts.join(' ');

      // Prepare the request payload
      const payload = {
        config: {
          emailTemplate: '',
          emailSubject: 'Plată Decizie Oncologică',
          notifyUrl: 'https://n8n.ovi.net.eu.org/webhook/plata',
          redirectUrl: `${window.location.origin}/payment-success?orderId=${orderId}`,
          language: 'ro'
        },
        payment: {
          options: {
            installments: 0,
            bonus: 0
          },
          instrument: {
            type: 'card'
          }
        },
        order: {
          ntpID: '',
          posSignature: POS_SIGNATURE,
          dateTime: new Date().toISOString(),
          description: 'Consultație medicală - A doua opinie oncologică',
          orderID: orderId,
          amount: 900,
          currency: 'RON',
          billing: {
            email: patientEmail,
            phone: '',
            firstName: firstName,
            lastName: lastName,
            city: 'Cluj-Napoca',
            country: 642,
            countryName: 'Romania',
            state: 'Cluj',
            postalCode: '400000',
            details: ''
          },
          shipping: {
            email: patientEmail,
            phone: '',
            firstName: firstName,
            lastName: lastName,
            city: 'Cluj-Napoca',
            country: 642,
            state: 'Cluj',
            postalCode: '400000',
            details: ''
          },
          products: [
            {
              name: 'Consultație medicală - A doua opinie oncologică',
              code: 'CONSULT-001',
              category: 'Medical Services',
              price: 900,
              vat: 21
            }
          ],
          installments: {
            selected: 0,
            available: [0]
          }
        }
      };

      // Make the request to Netopia using fetch with correct authorization
      const response = await fetch(NETOPIA_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'Authorization': AUTH_KEY
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Netopia error response:', errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Check if we got a payment URL
      if (data?.payment?.paymentURL) {
        return data.payment.paymentURL;
      } else {
        throw new Error('No payment URL received from Netopia');
      }
    } catch (error) {
      console.error('Error creating payment:', error);
      throw error;
    }
  },
  
  // Verify payment status with retries
  verifyPayment: async (orderId: string) => {
    try {
      // Add retries for payment status check
      const maxRetries = 10;
      const retryDelay = 2000; // 2 seconds

      for (let i = 0; i < maxRetries; i++) {
        const { data, error } = await supabase
          .from('payment_attempts')
          .select('status, payment_data')
          .eq('order_id', orderId)
          .single();
        
        if (error) {
          console.error('Error checking payment status:', error);
          // Wait before retrying
          await new Promise(resolve => setTimeout(resolve, retryDelay));
          continue;
        }
        
        // If payment is completed, return success
        if (data?.status === 'completed') {
          return {
            orderId,
            status: 'completed',
            verified: true
          };
        }

        // If payment data shows failure, return immediately
        if (data?.payment_data?.status === 12) {
          return {
            orderId,
            status: 'failed',
            verified: true,
            error: data.payment_data.message
          };
        }

        // Wait before next retry
        await new Promise(resolve => setTimeout(resolve, retryDelay));
      }

      throw new Error('Payment verification timeout');
    } catch (error) {
      console.error('Error verifying payment:', error);
      throw error;
    }
  }
};